import React from "react";
import { Switch } from "@mui/material";
import { useTheme } from "../contexts/ThemeContext";

const ThemeSwitch: React.FC = () => {
  const { isDarkMode, toggleTheme } = useTheme();

  return <Switch checked={isDarkMode} onChange={toggleTheme} color="default" />;
};

export default ThemeSwitch;
